import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, ArrowRightIcon, ShieldCheckIcon } from 'lucide-react';
export function Offer() {
  const features = ['Instalación y creación del agente (valor $750–$950) — GRATIS', 'Agente de texto en el canal que elijas: WhatsApp, Instagram Direct, Messenger o TikTok', 'Creado a tu imagen y semejanza: habla y responde como tu negocio', 'Acompañamiento, recolección de data y optimización durante 3 meses', 'Atención 24/7, los 365 días — como tener 3 colaboradores por el precio de 1'];
  return <section className="py-24 bg-navy-deep relative overflow-hidden" data-id="element-122">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/5 rounded-full blur-[120px] pointer-events-none" data-id="element-123" />

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-124">
        <div className="text-center mb-12" data-id="element-125">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/30 text-primary text-sm font-bold mb-8 uppercase tracking-wider" data-id="element-126">
            Cupos Limitados · Programa Caso de Estudio
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-127">
            Instalamos Tu Asistente de IA — Gratis. Tú Solo Pagas lo que Cuesta
            un Colaborador.
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-lg md:text-xl text-muted leading-relaxed max-w-3xl mx-auto" data-id="element-128">
            Te invitamos como caso de estudio: creamos tu agente de IA a la
            imagen de tu negocio, lo instalamos sin costo y te acompañamos 3
            meses optimizándolo con tu propia data.
          </motion.p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="bg-surface/80 backdrop-blur-md border-2 border-primary/40 rounded-3xl p-8 md:p-12 shadow-[0_0_50px_rgba(0,180,216,0.15)] relative overflow-hidden" data-id="element-129">
          {/* Subtle inner glow */}
          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-primary to-transparent opacity-50" data-id="element-130" />

          <div className="space-y-6 mb-10" data-id="element-131">
            {features.map((feature, index) => <div key={index} className="flex items-start gap-4" data-id="element-132">
                <CheckCircle2Icon className="w-6 h-6 text-primary shrink-0 mt-0.5" data-id="element-133" />
                <p className="text-white text-base md:text-lg" data-id="element-134">{feature}</p>
              </div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="relative mb-10 mx-auto max-w-sm" data-id="element-135">
            <div className="absolute -inset-3 bg-primary/20 rounded-2xl blur-2xl -z-10" data-id="element-136" />
            <div className="relative rounded-2xl overflow-hidden border border-primary/30 shadow-[0_0_40px_rgba(0,180,216,0.25)]" data-id="element-137">
              <img src="https://cdn.magicpatterns.com/uploads/dN9DAhRRLPUHxSbyzqMsCc/Imagen_pagina_Blas_2.jpg" alt="Fundador de CONECKTA usando el asistente de IA" className="w-full h-auto object-cover" data-id="element-138" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy-deep/50 via-transparent to-transparent pointer-events-none" data-id="element-139" />
            </div>
          </motion.div>

          <div className="border-t border-primary/20 pt-8 text-center" data-id="element-140">
            <div className="mb-6" data-id="element-141">
              <span className="text-5xl md:text-6xl font-extrabold text-white tracking-tight" data-id="element-142">
                $250
              </span>
              <span className="text-xl text-muted font-medium" data-id="element-143"> / mes</span>
            </div>
            <p className="text-muted text-sm md:text-base max-w-2xl mx-auto mb-8" data-id="element-144">
              Lo mismo que te cuesta un solo colaborador — trabajando un turno.
              Tu agente trabaja los 3 turnos, los 7 días, sin pasivos laborales.
            </p>

            <a href="https://wa.link/cesnp8" target="_blank" rel="noopener noreferrer" className="btn-cta w-full md:w-auto text-lg px-10 py-5 group" data-id="element-145">
              Quiero Aplicar al Programa
              <ArrowRightIcon className="w-6 h-6 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-146" />
            </a>

            <div className="mt-6 flex items-center justify-center gap-2 text-sm text-muted" data-id="element-147">
              <ShieldCheckIcon className="w-4 h-4 text-primary" data-id="element-148" />
              Garantía: ajustamos tu agente hasta que funcione como tu negocio
              lo necesita.
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}